export default __webpack_public_path__ + "static/media/regex.cca771e6.png";